// prop type klub
// fill color
// map enum
import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  key?: string;
}

const KlubBackgroundIcon: NextPage<Props> = ({
  width = "515",
  height = "179",
  color = "#52A4FF",
  key = "diving",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 628 279"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M574.031 278.5C607.147 249.226 627.927 207.077 627.927 160.253C627.927 71.7828 553.618 0 461.907 0C421.596 0 384.589 13.8818 355.805 36.9703L355.658 37.1142C354.483 38.0492 315.64 71.9267 279 103.934C242.36 71.9267 203.517 38.0492 202.342 37.1142L202.195 36.9703C173.412 13.8818 136.478 0 96.0926 0C4.38187 0 -70 71.7828 -70 160.325C-70 207.077 -49.1466 249.226 -16.0309 278.5C-49.1466 307.846 -70 349.923 -70 396.747C-70 485.289 4.38187 557 96.0926 557C136.404 557 173.412 543.118 202.195 520.03L202.342 519.886C203.517 518.951 242.36 485.073 279 453.066C315.64 485.073 354.483 518.951 355.658 519.886L355.805 520.03C384.589 543.118 421.522 557 461.907 557C553.618 557 628 485.217 628 396.747C628 349.923 607.22 307.846 574.104 278.5H574.031ZM96.0926 84.2261C119.736 84.2261 136.698 93.5046 146.904 101.489C152.705 106.523 181.268 131.41 214.384 160.325C181.342 189.167 152.705 214.126 146.904 219.161C136.624 227.216 119.663 236.423 96.0926 236.423C51.8893 236.423 15.9834 202.258 15.9834 160.325C15.9834 118.391 51.9628 84.2261 96.0926 84.2261ZM146.978 455.583C136.698 463.639 119.736 472.846 96.166 472.846C51.9628 472.846 16.0568 438.681 16.0568 396.747C16.0568 354.814 52.0362 320.649 96.166 320.649C119.736 320.649 136.698 329.928 146.978 337.911C152.778 342.946 181.342 367.833 214.457 396.747C181.415 425.59 152.778 450.549 146.978 455.583ZM208.143 278.5C220.405 267.855 250.363 241.674 279.073 216.643C312.263 187.657 343.616 160.253 343.616 160.253C376.732 131.41 405.295 106.451 411.096 101.417C421.376 93.3608 438.337 84.1542 461.907 84.1542C506.111 84.1542 542.017 118.319 542.017 160.253C542.017 202.186 506.037 236.351 461.907 236.351C421.596 236.351 384.589 250.233 355.805 273.321L355.658 273.465C355.438 273.681 349.931 278.428 349.931 278.428C349.931 278.428 307.71 315.255 279 340.285C250.363 315.255 220.405 289.145 208.069 278.428L208.143 278.5ZM461.907 472.846C438.337 472.846 421.376 463.567 411.096 455.583C405.295 450.549 376.732 425.662 343.616 396.747C376.658 367.905 405.295 342.946 411.096 337.911C421.376 329.856 438.337 320.649 461.907 320.649C506.111 320.649 542.017 354.814 542.017 396.747C542.017 438.681 506.037 472.846 461.907 472.846Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubBackgroundIcon;
